import { baseApi } from '@/store/api/baseApi';
import type {
  SendCustomerNotificationPayload,
  SendCustomerNotificationResult,
} from '@/types/notification';

export const notificationsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    sendCustomerNotification: builder.mutation<
      SendCustomerNotificationResult,
      SendCustomerNotificationPayload
    >({
      query: (body) => ({
        url: '/notifications/send',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useSendCustomerNotificationMutation } = notificationsApi;
